import styled from 'styled-components';

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(255, 255, 255, 0.96);
`;

export const Body = styled.div`
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

export const ThumbnailWrapper = styled.div`
  width: 100%;
  -webkit-touch-callout: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
`;
